/**
 * Converte as declaracoes `nav` dos modulos no mapa que o buildMenu consome.
 *
 * Separado do navRegistry porque este arquivo nao pode depender do Vite: e
 * assim que ele fica testavel com `node --test`.
 */
export function navFromModules(modules = {}) {
    return Object.values(modules).reduce((map, module) => {
        const nav = module?.nav;

        if (!nav?.section || !nav?.title) {
            return map;
        }

        map[`${nav.section}/${nav.title}`] = {
            icon: nav.icon,
            route: nav.route,
            accordion: nav.accordion ?? false,
        };

        return map;
    }, {});
}

/**
 * As declaracoes `nav` cruas, como os modulos escreveram.
 *
 * O `navFromModules` acima achata para o mapa por caminho de titulos, que era o
 * que o buildMenu antigo consumia. Este devolve o objeto inteiro -- com
 * `section`, `permission` e `sequence` -- porque o `buildModuleMenu` monta a
 * estrutura a partir dele, sem passar por casamento de texto.
 */
export function navsFromModules(modules = {}) {
    return Object.values(modules)
        .map((module) => module?.nav)
        .filter((nav) => nav?.title && nav?.route);
}

/**
 * Lista plana dos modulos declarados, na ordem em que o glob os entrega.
 *
 * O menu normal vem da arvore de permissoes do /appmenu. Este aqui e a rede de
 * seguranca: usuario de grupo admin ignora a arvore, e enquanto o catalogo
 * proprio do accounts nao estiver cadastrado a arvore volta vazia para todo
 * mundo. Sem isto, quem precisa entrar para *criar* o catalogo nao teria como
 * navegar ate a tela.
 */
export function declaredModules(modules = {}) {
    return Object.values(modules)
        .map((module) => module?.nav)
        .filter((nav) => nav?.title && nav?.route)
        .map((nav) => ({ title: nav.title, icon: nav.icon || 'folder', route: nav.route }));
}
